import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';
import { ProjectModel } from '../../../../services/project.model.service';
import { FeatureFlagService } from '../../../../services/core.feature-flags.service';

@Component({
  selector: 'project-admin-header',
  template: require('./project.admin.header.html')
})
export class ProjectAdminHeaderComponent implements OnInit {
  @Input() project: any;
  @Input() modules: any;
  @Input() isProjectAdmin: any;
  @Input() projectMenu: any;

  data: any;
  moduleEnabled: any;
  scmEnabled: any;

  constructor(
    protected stateService: StateService,
    private projectModel: ProjectModel,
    public featureFlagService: FeatureFlagService
  ) { }

  ngOnInit(): void {
    this.data = {
      project: this.project,
      modules: _.cloneDeep(this.modules),
      originalModules: this.modules,
      saving: false
    };
    this.projectModel.data = this.data;
    this.moduleEnabled = this.projectModel.originalModuleEnabled;
    this.scmEnabled = this.projectModel.scmEnabled;
  }
}
